module.exports = __webpack_public_path__ + "img/img3.fa2b486.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/06/img3.png
// module id = 267
// module chunks = 0